export const getAverage = (array: (string | number)[]) =>
  (array.reduce((acc, it) => Number(acc) + Number(it), 0) as number) / array.length;
